import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { CustomerFormComponent } from './../components/customer-form/customer-form';
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';

import { AboutPage } from '../pages/about/about';
import { ContactPage } from '../pages/contact/contact';
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { DocumentParserProvider } from '../providers/document-parser/document-parser';
import { DataServiceProvider } from '../providers/data-service/data-service';
import { PrintPreviewPage } from '../pages/print-preview/print-preview';
import { SplashPage } from '../pages/splash/splash';

//db
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { environment } from './environment/environment';
import { AuthServiceProvider } from '../providers/auth-service/auth-service';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { BillingPage } from '../pages/billing/billing';
import { PostVechileStatusComponent } from '../components/post-vechile-status/post-vechile-status';
import { CommercialsComponent } from '../components/commercials/commercials';
import { NextVisitComponent } from '../components/next-visit/next-visit';
import { BillPreviewPage } from '../pages/bill-preview/bill-preview';
import { DataBaseProvider } from '../providers/data-base/data-base';
import { BusinessProvider } from '../providers/business/business';
import { ListBillingPage } from '../pages/list-billing/list-billing';
import { SettingsPage } from '../pages/settings/settings';
import { AllUsersPage } from '../pages/all-users/all-users';
import { UserDetailsPage } from '../pages/user-details/user-details';
import { DailyActivityPage } from '../pages/daily-activity/daily-activity';
import { ActivitesPage } from '../pages/activites/activites';

@NgModule({
  declarations: [
    MyApp,
    // pages
    AboutPage,
    ContactPage,
    HomePage,
    TabsPage,
    PrintPreviewPage,
    SplashPage,
    BillingPage,
    BillPreviewPage,
    ListBillingPage,
    SettingsPage,
    AllUsersPage,
    UserDetailsPage,
    DailyActivityPage,
    ActivitesPage,
    // components
    CustomerFormComponent,
    PostVechileStatusComponent,
    CommercialsComponent,
    NextVisitComponent,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    // pages
    AboutPage,
    ContactPage,
    HomePage,
    TabsPage,
    PrintPreviewPage,
    SplashPage,
    BillingPage,
    BillPreviewPage,
    ListBillingPage,
    SettingsPage,
    AllUsersPage,
    UserDetailsPage,
    DailyActivityPage,
    ActivitesPage,
    // components
    CustomerFormComponent,
    PostVechileStatusComponent,
    CommercialsComponent,
    NextVisitComponent,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    DocumentParserProvider,
    DataServiceProvider,
    AuthServiceProvider,
    DataBaseProvider,
    BusinessProvider
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts